import React from 'react';
import { CircularProgress, CircularProgressProps, Box } from '@mui/material';

export const CircularProgressBar: React.FC<CircularProgressProps> = (props) => {
    return (
        <>
            <React.Fragment>
                <svg width={0} height={0} style={{ position: 'absolute' }}>
                    <defs>
                        <linearGradient id="circular_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="10%" stopColor="rgba(232, 232, 232, 0)" />
                            <stop offset="90%" stopColor="rgba(232, 232, 232, 1)" />
                        </linearGradient>
                    </defs>
                </svg>
            </React.Fragment>

            <Box sx={{ position: 'relative' }}>
                <CircularProgress
                    data-testid="circularProgress-element"
                    variant="determinate"
                    sx={{
                        color: 'transparent',
                    }}
                    size={120}
                    thickness={2}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    sx={{
                        animationDuration: '1000ms',
                        position: 'absolute',
                        left: 0,
                        '& .MuiCircularProgress-circle': {
                            stroke: 'url(#circular_gradient)',
                            strokeLinecap: 'round',
                        },
                    }}
                    size={120}
                    thickness={2}
                    {...props}
                />
            </Box>
        </>
    );
};

export const ArcCircularGauge: React.FC<CircularProgressProps> = (props) => {
    return (
        <>
            <React.Fragment>
                <svg width={0} height={0} style={{ position: 'absolute' }}>
                    <defs>
                        <linearGradient id="arc_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="10%" stopColor="rgba(232, 232, 232, 0)" />
                            <stop offset="90%" stopColor="rgba(232, 232, 232, 1)" />
                        </linearGradient>
                    </defs>
                </svg>
            </React.Fragment>

            <Box sx={{ position: 'relative' }}>
                <CircularProgress
                    data-testid="gauge-element"
                    variant="determinate"
                    sx={{
                        color: 'rgba(232, 232, 232, 0.3)',
                    }}
                    style={{transform: 'rotate(136deg)'}}

                    size={120}
                    thickness={2}
                    {...props}
                    value={75}
                />
                <CircularProgress
                    variant="determinate"
                    sx={{
                        position: 'absolute',
                        left: 0,
                        '& .MuiCircularProgress-circle': {
                            stroke: 'url(#arc_gradient)',
                            strokeLinecap: 'round',
                        },
                    }}
                    style={{transform: 'rotate(136deg)'}}
                    size={120}
                    thickness={2}
                    value={50}

                    {...props}
                />
            </Box>
        </>
    );
};
